module.exports = __webpack_public_path__ + "img/logo.6f7eb862.png";